<button [type]="btnType" [disabled]="disabled" class="sg-btn"
    [class.sg-btn--secondary]="btnStyle === 'secondary'"
    [class.sg-btn--tertiary]="btnStyle === 'tertiary'"
    [class.sg-btn--small]="btnSize === 'small'"
    [class.sg-btn--xsmall]="btnSize === 'xsmall'"
    [class.sg-btn--large]="btnSize === 'large'"
    [class.sg-btn--shadow]="btnShadow"
    [class.w-100]="fullWidth"
 >
    <span *ngIf="button && button.iconBefore">
        <mlp-ng-icon [name]="button.iconBefore"
            [class.sg-color]="button.iconStyle"
            [class.-primary]="button.iconStyle === 'primary'"
            [class.-secondary]="button.iconStyle === 'info'"
            [class.-danger]="button.iconStyle === 'danger'"
        ></mlp-ng-icon>
    </span>
    <span *ngIf="loading">
        <mlp-ng-spinner></mlp-ng-spinner>
    </span>{{ label ? label : button.label }}<span *ngIf="button && button.labelSecondary || labelSecondary" class="sg-btn--label">
        {{button && button.labelSecondary ? button.labelSecondary : labelSecondary}}
    </span>
</button>
